"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var MountReactComponent_1 = __importDefault(require("MountReactComponent/MountReactComponent"));
var CreatePageFlow_1 = __importDefault(require("CreatePageFlow"));
var Utils_1 = require("Utils/Utils");
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var types_1 = require("CreatePageFlow/types");
var CreatePageBackground_1 = require("./CreatePageBackground");
var lodash_1 = require("lodash");
var Types_2 = require("@CommonFrontendBackend/Tokens/Types");
require("CreatePageApp/CreatePageApp.ng.html");
var templateUrl = "CreatePageApp/CreatePageApp.ng.html";
var INTEGRATION_NAME_PARAM = "integration-name";
var ZohoCreatePageAppParamKeys;
(function (ZohoCreatePageAppParamKeys) {
    ZohoCreatePageAppParamKeys["ObjectType"] = "object-type";
    ZohoCreatePageAppParamKeys["ObjectId"] = "object-id";
})(ZohoCreatePageAppParamKeys || (ZohoCreatePageAppParamKeys = {}));
var PipedriveCreatePageAppParamKeys;
(function (PipedriveCreatePageAppParamKeys) {
    PipedriveCreatePageAppParamKeys["ObjectType"] = "resource";
    PipedriveCreatePageAppParamKeys["ObjectId"] = "selectedIds";
})(PipedriveCreatePageAppParamKeys || (PipedriveCreatePageAppParamKeys = {}));
var showCreatePageApp = function ($scope, createUi, di) {
    var modal = di.get("modal");
    var apiBaseUrl = di.get("apiBaseUrl");
    var rootDataStore = di.get("rootDataStore");
    var useHistoryDataStore = rootDataStore.userDataStore.useHistoryDataStore;
    var telemetry = di.get("telemetry");
    var serverTelemetry = di.get("serverTelemetry");
    $scope.ui = {
        createPageApp: (0, MountReactComponent_1.default)(createUi)(react_1.default.createElement(CreatePageBackground_1.CreatePageAppBackground, null)),
    };
    var urlSearchParams = (0, Utils_1.getParamsFromAngularUrl)(document.location.href);
    var integrationName = urlSearchParams.get(INTEGRATION_NAME_PARAM);
    var objectDetails = parseObjectDetails(integrationName, urlSearchParams);
    modal.showSimpleModal({
        containerClassName: "standalone-create-page-app-modal",
        isEscapable: false,
        body: (0, CreatePageFlow_1.default)({
            flowOrigin: __assign({ source: types_1.CreatePageFlowSource.Crm, integrationName: integrationName }, objectDetails),
            apiBaseUrl: apiBaseUrl,
            accountId: rootDataStore.getAccountDataStore().id,
            telemetry: telemetry,
            serverTelemetry: serverTelemetry,
            prompts: {
                pageStateLive: {
                    show: useHistoryDataStore.shouldShowPageStateChangeConfirmationModal(Types_1.ProjectStatus.Live),
                    onHide: function () {
                        useHistoryDataStore.hidePageStateChangeConfirmationModal(Types_1.ProjectStatus.Live);
                    },
                },
            },
        }),
    });
};
var parseObjectDetails = function (integrationName, urlSearchParams) {
    switch (integrationName) {
        case Types_2.ProviderType.Zoho:
            return {
                objectType: urlSearchParams.get(ZohoCreatePageAppParamKeys.ObjectType),
                objectId: urlSearchParams.get(ZohoCreatePageAppParamKeys.ObjectId),
            };
        case Types_2.ProviderType.Pipedrive:
            return {
                objectType: (0, lodash_1.capitalize)(pluralise(urlSearchParams.get(PipedriveCreatePageAppParamKeys.ObjectType))),
                objectId: urlSearchParams.get(PipedriveCreatePageAppParamKeys.ObjectId),
            };
        default:
            throw new Error("Could not find integration: ".concat(integrationName));
    }
};
var pluralise = function (word) {
    return word + "s";
};
exports.default = angular.module("qwilr.createPageApp", ["ui.router"]).config(function ($stateProvider) {
    $stateProvider.state("createPageApp", {
        url: "/page/create-from-template",
        templateUrl: templateUrl,
        controller: function ($scope, createUi, $rootScope) {
            var di = $rootScope.di.child();
            showCreatePageApp($scope, createUi, di);
        },
    });
});
